// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { FactoryWithChoiceContext } from '@digitalasset/utility-operator-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useUtilityRegistryApiClient } from '../../../../../contexts/UtilityRegistryApiContext';

export const useCreateMintRequestContext: () => UseMutationResult<
  FactoryWithChoiceContext,
  string,
  {
    registrar: string;
    holder: string;
    instrumentId: string;
  }
> = () => {
  const registryApi = useUtilityRegistryApiClient();

  return useMutation({
    mutationKey: ['createMintRequestContext', registryApi],
    mutationFn: async ({ registrar, holder, instrumentId }) => {
      const requestMintRequest = {
        holder,
        instrumentId: {
          admin: registrar,
          id: instrumentId,
        },
      };
      return registryApi.getMintRequestCreateContext(requestMintRequest);
    },
  });
};
